<script setup lang="ts">
import { SimpleDialog, SimpleDialogOverlay } from "ls/components/simple-dialog";
import { DialogContent, DialogDescription, DialogPortal, DialogTitle } from "reka-ui";
import { ref } from "vue";
import Command from "./Command.vue";
import { useProvideCommandContext } from "./context";

defineProps<{
  title: string;
  description: string;
}>();

const searchTerm = defineModel<string>("searchTerm");
useProvideCommandContext({
  searchTerm,
  isLoading: ref(false),
});
</script>

<template>
  <SimpleDialog v-slot="{ close }">
    <DialogPortal>
      <DialogContent
        class="fixed inset-0 w-screen overflow-y-auto data-[state=closed]:animate-dialog-out data-[state=open]:animate-dialog-in sm:pt-0"
      >
        <div
          class="grid h-full grid-rows-1 justify-items-center sm:grid-rows-[minmax(0,15%)_auto] sm:p-4"
          @click.self="close"
        >
          <div
            class="w-full min-w-0 overflow-hidden rounded-2xl border border-slate-200/50 shadow-[0_9px_48px_0,0_6px_24px_0,0_1px_1px_0] shadow-black/10 sm:row-start-2 sm:mb-auto sm:max-w-2xl"
            @close-auto-focus.prevent
          >
            <DialogTitle v-if="title" class="sr-only">
              {{ title }}
            </DialogTitle>
            <DialogDescription v-if="description" class="sr-only">
              {{ description }}
            </DialogDescription>
            <Command>
              <slot />
            </Command>
          </div>
        </div>
      </DialogContent>
    </DialogPortal>
  </SimpleDialog>
</template>
